import { KnownTracker, KnownTrackersArchive } from "./KnownTrackers";

const {trackers} = KnownTrackersArchive;

const knownTrackersByDomain = new Map<string, KnownTracker>();
for (const tracker of trackers) {
	const domains = Array.isArray(tracker.domains) ? tracker.domains : [tracker.domains];
	for (const domain of domains) {
		knownTrackersByDomain.set(domain, tracker);
	}
}

export const getKnownTracker = (forDomain?: string) => {
	if (forDomain == null) return;
	const domainComponents = forDomain.split(".");
	for (let i = 0; i < domainComponents.length; i++) {
		const tracker = knownTrackersByDomain.get(domainComponents.slice(i).join("."));
		if (tracker != null) {
			return tracker;
		}
	}
	return;
}
